import { IBaseRequest } from "../types/models";
import "reflect-metadata";

export abstract class BaseRequest implements IBaseRequest {
  // Serialize method to convert the object to a JSON representation
  serialize(): Record<string, any> {
    const serialized: Record<string, any> = {};

    // Get all property names of the class
    const propertyNames = Object.getOwnPropertyNames(this);

    // Loop through properties and add them to the serialized object
    for (const propertyName of propertyNames) {
      //@ts-ignore
      if (typeof this[propertyName] !== "function") {
        const jsonKey =
          Reflect.getMetadata("jsonName", this, propertyName) || propertyName;

        //@ts-ignore
        serialized[jsonKey] = this[propertyName];
      }
    }

    return serialized;
  }
}
